import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const UpdateCourseDialog = (props) => {
  const {
    show,
    handleClose,
    lngsltd,
    editCourseName,
    setEditCourseName,
    editCourseNameError,
    editCourseDes,
    setEditCourseDes,
    editGrpName,
    setEditGrpName,
    groupData,
    editGrpNameError,
    handleUpdate
  } = props;

  // Ensure groupData is always an array
  const safeGroupData = Array.isArray(groupData) ? groupData : [];

  return (
    <Dialog open={show} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ backgroundColor: '#efedf0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {lngsltd["Update details"]}
        <IconButton onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {/* Course Name Field */}
        <Box mb={3}>
          <TextField
            label={
              <Box component="span">
                {lngsltd["Course Name"]}:
                <Box component="span" color="error.main">
                  *
                </Box>
              </Box>
            }
            placeholder={lngsltd["Enter Course Name"]}
            fullWidth
            value={editCourseName}
            onChange={(e) => setEditCourseName(e.target.value)}
            error={Boolean(editCourseNameError)}
            helperText={editCourseNameError}
          />
        </Box>

        {/* Description Field */}
        <Box mb={3}>
          <TextField
            label={`${lngsltd["Description"]}:`}
            placeholder={lngsltd["Enter Course Description"]}
            fullWidth
            value={editCourseDes}
            onChange={(e) => setEditCourseDes(e.target.value)}
          />
        </Box>

        {/* Select Group Field */}
        <Box mb={3}>
          <FormControl fullWidth error={Boolean(editGrpNameError)}>
            <InputLabel>
              <Box component="span">
                {lngsltd["Select Group"]}:
                <Box component="span" color="error.main">
                  *
                </Box>
              </Box>
            </InputLabel>
            <Select
              value={editGrpName}
              onChange={(e) => setEditGrpName(e.target.value)}
              label={lngsltd["Select Group"]}
            >
              <MenuItem value="" disabled>
                {lngsltd["Select Group"]}
              </MenuItem>
              {safeGroupData.map((group) => (
                <MenuItem key={group.groupID} value={group.groupName}>
                  {group.groupName}
                </MenuItem>
              ))}
            </Select>
            {editGrpNameError && (
              <FormHelperText>{editGrpNameError}</FormHelperText>
            )}
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="success"
          onClick={handleUpdate}
        >
          {lngsltd["Save"]}
        </Button>
        <Button
          variant="outlined"
          onClick={handleClose}
        >
          {lngsltd["Cancel"]}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UpdateCourseDialog;